import React, { useEffect } from "react";

const NotFoundPage = ({ children }) => {
    useEffect(() => {
        // Dynamically add the required CSS files from the public directory
        const addStylesheet = (href) => {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = `${process.env.PUBLIC_URL}${href}`;
            document.head.appendChild(link);
            return link;
        };

        const stylesheets = [
            "/404/css/style.css",
        ];

        const links = stylesheets.map(addStylesheet)


        const addScripts = (href) => {
            const link = document.createElement("script");
            link.type = "text/javascript";
            link.src = `${process.env.PUBLIC_URL}${href}`;
            document.head.appendChild(link);
            return link;
        };

        const scripts = [
            "/404/js/jquery.min.js",
            "/404/js/bootstrap.min.js",
            "/404/js/particles.js"
        ];

        const sources = scripts.map(addScripts)


        // Clean up on component unmount
        return () => {
            links.forEach((link) => {
                document.head.removeChild(link);
            });
            sources.forEach((link) => {
                document.head.removeChild(link);
            });
        };

        //Add scripts


    }, []);

    return (
        <div className="flat">
            <div id="particles-js"></div>


            <a href="#" className="logo-link" title="back home">

                <img src="\libraries\assets\images\logo.png" className="logo" alt="Company's logo"/>

            </a>

            <div className="content">

                <div className="content-box">

                    <div className="big-content">


                        <div className="list-square">
                            <span className="square"></span>
                            <span className="square"></span>
                            <span className="square"></span>
                        </div>


                        <div className="list-line">
                            <span className="line"></span>
                            <span className="line"></span>
                            <span className="line"></span>
                            <span className="line"></span>
                            <span className="line"></span>
                            <span className="line"></span>
                        </div>


                        <i className="fa fa-search" aria-hidden="true"></i>


                        <div className="clear"></div>

                    </div>


                    <h1>Oops! WE lost you.</h1>

                    <p>The page you were looking for doesn't exist or
                        may have moved.</p>
                    <p>Go <a href="/dashboard">Back to Home</a> and try again</p>

                </div>

            </div>
        </div>

    );
};

export default NotFoundPage;